<template>
  <div id="financial_reports">
    <div class="financialTitle">{{ FinancialReports }}</div>
    <div v-if="loadTabs"
      style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center; min-height: calc(100vh - ( 280px + 170px));">
      <Loader />
    </div>
    <div v-if="error && !loadTabs" class="full-screen">
      <Error />
    </div>
    <div v-if="years.length > 0 && !loadTabs" class="TabsContainer ">
      <v-tabs v-model="tab" background-color="#FFFFFF" color="#1D1D1D" grow centered show-arrows
        class="financialTab innerTabContainer">
        <v-tabs-slider color="#FFCB05"></v-tabs-slider>
        <v-tab v-for="(item, i) in years" :key="i">
          {{ item.year }}
        </v-tab>
      </v-tabs>
    </div>
    <div class="mainFinancial" v-if="!error && !loadTabs">
      <v-tabs-items v-model="tab" class="financialTab">
        <v-tab-item v-for="(item, i) in years" :key="i">
          <div class="pdfContainer">
            <div v-if="item.loadData" class="full-screen">
              <Loader />
            </div>
            <div v-if="item.errorData & !item.loadData" class="full-screen">
              <Error />
            </div>
            <table class="w-100">
              <tr v-for="(file, index) in files[tab]" :key="index">
                <div @click="downloadFile(file.id)" :class="[lang === 'ar' ? 'right-dir' : '', 'pdf']">
                  <div><img src="../../assets/icons/pdf.svg" class="pdfImage"></div>
                  <div class="pdfText" :class="[lang === 'ar' ? 'arabicFont' : '', '']">{{
                    getDisplayFileName(file.reportDate) }}</div>
                </div>
              </tr>
            </table>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import FinancialReportsYearsRepository from '../../repositories/FinancialReportsYearsRepository'
import FinancialReportsRepository from '../../repositories/FinancialReportsRepository'
import DownloadFinancialReports from '../../repositories/DownloadFinancialReports'
import gc from '../../utils/gc'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
export default {
  name: 'FinancialReports',
  components: { Loader, Error },
  data () {
    return {
      lang: this.$lang,
      financeYearsRepo: new FinancialReportsYearsRepository(),
      financialRepo: new FinancialReportsRepository(),
      FinancialReports: this.$t('FinancialReports.title'),
      downloadFinanceRepo: new DownloadFinancialReports(),
      tab: null,
      years: [],
      files: [],
      loadTabs: false,
      error: false,
      loadData: false,
      errorData: false,
      fetchedTabs: []
    }
  },
  watch: {
    async tab (val) {
      if (this.fetchedTabs.includes(val)) {
        return
      }
      const tab = val
      $('.financialTab .v-tab').css('transform', 'rotateY(0deg)')
      this.years[val].loadData = true
      try {
        const response = await this.financialRepo.getById(this.years[tab].year)
        if (response.status === 200) {
          this.fetchedTabs.push(tab)
          for (let i = 0; i < response.data.length; i++) {
            this.files[tab].push({
              file: gc.baseUrl + '/customerCare' + response.data[i].reportFile,
              reportDate: response.data[i].reportDate,
              id: response.data[i].id
            })
          }
          this.years[val].loadData = false
          this.years[val].errorData = false
        } else {
          this.years[val].loadData = false
          this.years[val].errorData = true
        }
      } catch (e) {
        this.years[val].loadData = false
        this.years[val].errorData = true
        return e
      }
      this.years[val].loadData = false
      this.arabic()
    }
  },
  created () {
    this.arabic()
  },
  mounted () {
    this.getYears()
  },
  methods: {
    arabic () {
      if (this.$lang === 'ar') {
        $('#financial_reports').css('direction', 'rtl')
        $('.innerTabContainer').css('direction', 'ltr')
        $('.innerTabContainer').css('transform', 'rotateY(180deg)')
        $('.financialTab .v-tab').css('transform', 'rotateY(180deg)')
        $('.financialTitle').addClass('arabicFont')
      }
    },
    async getYears () {
      this.loadTabs = true
      try {
        const response = await this.financeYearsRepo.get()
        this.loadTabs = false
        if (response.status === 200) {
          this.years = []
          for (let i = 0; i < response.data.length; i++) {
            this.years.push({ year: response.data[i], loadData: false, errorData: false })
            this.files.push([])
          }
          this.error = false
        } else {
          this.error = true
        }
      } catch (e) {
        this.error = true
      }
      this.loadTabs = false
    },
    async downloadFile (id) {
      // Download the file as it is from the server without any name changes
      const a = document.createElement('a')
      a.href = `${gc.baseUrl}/customerCare/api/financeReport/download/${id}`
      a.download = '' // Let the server determine the filename
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    getDisplayFileName (reportDate) {
      // if (!reportDate) return 'Financial List For'

      try {
        // Simply display "Financial List For" followed by the reportDate
        return `Financial List For ${reportDate}`
      } catch (error) {
        console.error('Error formatting date:', error)
        return `Financial List For ${reportDate}`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/sass/main";
@import "src/assets/sass/modules/tabs";

.full-screen {
  min-height: calc(100vh - (170px + 80px + 50px + 285.6px));

  .loader,
  .error-container {
    min-height: calc(100vh - (170px + 80px + 50px + 285.6px)) !important;
  }
}

#financial_reports {
  background-image: linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -moz-background-image: -moz-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -o-background-image: -o-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  -webkit-background-image: -webkit-linear-gradient(to bottom, #F2F2F2, rgba(225, 225, 225, 0.5));
  margin: 160px 0px 0 0 !important;
  min-height: calc(100vh - (160px + 288.6px));
}

#financial_reports .TabsContainer {
  box-shadow: 10px 13px 16px -6px rgba(0, 0, 0, 0.1) !important;
}

.financialTitle {
  padding: 20px 20px;
  font-family: 'Mtn-bold';
  color: #FFCB05;
  font-size: x-large;
}

.pdfContainer {
  padding: 15vh 4vw 5vh 4vw;
}

.pdfContainer tr {
  height: 80px;
}

.pdf {
  display: flex;
  cursor: pointer;
}

.pdfImage {
  padding: 10px;
}

.pdfText {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  font-family: Mtn-bold;
}

.arabicFont {
  font-family: Mtn-arabic-bold !important;
}

.grayBackground {
  background-image: linear-gradient(to top, #F2F2F2, #e1e1e1cf);
}
</style>
<style lang="scss">
.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.v-tabs-slider-wrapper {
  height: 4px !important;
  bottom: -2px !important;
}

.mainFinancial {
  background-image: url('../../assets/icons/financialReport.svg') !important;
  background-repeat: no-repeat;
  min-height: 476px;
  background-position-x: right;
}
</style>
<style lang="scss" scoped>
@media (max-width: 1000px) {
  #financial_reports {
    min-height: calc(100vh - (170px + 392.2px));
  }

  .full-screen {
    min-height: calc(100vh - (170px + 80px + 50px + 285.6px));

    .loader,
    .error-container {
      min-height: calc(100vh - (170px + 80px + 50px + 285.6px)) !important;
    }
  }
}

@media (max-width: 575px) {
  #financial_reports {
    min-height: calc(100vh - (170px + 814.6px));
  }

  .full-screen {
    min-height: calc(100vh - (170px + 80px + 50px + 285.6px));

    .loader,
    .error-container {
      min-height: calc(100vh - (170px + 80px + 50px + 285.6px)) !important;
    }
  }
}

#financial_reports {
  .theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active) {
    color: rgba(29, 29, 29, 0.6) !important;
  }

  .v-tabs {
    height: 100%;
    border-bottom: none !important;
    padding: 0 0 !important;
  }

  .v-tab {
    font-size: 12px !important;
    border-bottom: 2px solid #ffffff;
  }

  .v-tab.v-tab--active {
    color: #FFCB05;
  }

  .v-window.v-item-group.theme--light.v-tabs-items {
    background: transparent;
  }
}
</style>
